import { render, staticRenderFns } from "./SearchFilterTagList.vue?vue&type=template&id=a71d8dbe"
import script from "./SearchFilterTagList.vue?vue&type=script&lang=ts"
export * from "./SearchFilterTagList.vue?vue&type=script&lang=ts"
import style0 from "./SearchFilterTagList.vue?vue&type=style&index=0&id=a71d8dbe&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports